// src/data/difficulty.js

export const DIFFICULTY_LEVELS = {
  "Easy": {
    label: "Easy",
    description: "Associate is receptive to feedback and accepts coaching readily",
    prompt: "DIFFICULTY: EASY - You are generally receptive to feedback. After 1-2 manager responses, begin showing openness and acceptance. When the manager provides good coaching, acknowledge it and show willingness to change. End the conversation naturally by saying things like 'That makes sense, I'll work on that' or 'Thanks for the feedback, I understand what I need to do now.'"
  },
  "Medium": {
    label: "Medium", 
    description: "Associate pushes back moderately but eventually accepts feedback",
    prompt: "DIFFICULTY: MEDIUM - You are somewhat resistant initially. Push back 2-3 times with your chosen mood, but when the manager shows good coaching skills (active listening, clear examples, collaborative approach), gradually become more receptive. Once you feel heard and understood, accept their guidance and naturally conclude with 'I appreciate you taking the time to explain this' or similar."
  },
  "Hard": {
    label: "Hard",
    description: "Associate is very resistant and requires persistent, skilled coaching",
    prompt: "DIFFICULTY: HARD - You are quite resistant to feedback and change. Maintain your chosen mood strongly, but even you have limits. If the manager demonstrates excellent coaching skills over multiple exchanges (empathy, specific examples, collaborative problem-solving), eventually soften your stance. When they've truly earned your respect through skilled coaching, acknowledge it and show readiness to move forward."
  }
};

export const DEFAULT_DIFFICULTY = "Easy";